import MaintenanceEventReducer from './MaintenanceEventReducer.js';
import Constants from '../Constants.js';
const {
  getMaintenanceEvent,
  getStatus,
  getError
} = MaintenanceEventReducer;
const {
  MAINTENANCE_EVENT_REMOVE,
  MAINTENANCE_EVENT_STATUS,
  MAINTENANCE_EVENT_GET,
  MAINTENANCE_EVENT_UPDATE
} = Constants;
class MaintenanceEvent {
  constructor(projectId, id) {
    this.projectId = projectId || process?.env?.projectId;
    this.id = id;
  }
  createAction(method, status, func) {
    return (dispatch, getState, opts) => {
      const projectId = this.projectId || opts && opts.api && opts.api.projectId;
      dispatch({
        type: MAINTENANCE_EVENT_STATUS,
        status,
        projectId
      });
      return func(dispatch, getState, opts, projectId).catch(error => {
        dispatch({
          type: MAINTENANCE_EVENT_STATUS,
          projectId,
          status: `${method}Error`,
          error
        });
        return Promise.reject(error);
      });
    };
  }
  get(opts) {
    return this.createAction('load', 'loading', async (dispatch, getState, {
      api
    }, projectId = this.projectId) => {
      let getEventReq = api;
      if (projectId) {
        getEventReq = getEventReq.project(projectId);
      }
      const r = await getEventReq.maintenanceEvent(this.id).get();
      dispatch({
        type: MAINTENANCE_EVENT_GET,
        projectId,
        event: r
      });
      return r;
    });
  }
  update(data) {
    return this.createAction('update', 'updating', async (dispatch, getState, {
      api
    }, projectId = this.projectId) => {
      let updateEventReq = api;
      if (projectId) {
        updateEventReq = updateEventReq.project(projectId);
      }
      const r = await updateEventReq.maintenanceEvent(this.id).update(data);
      dispatch({
        type: MAINTENANCE_EVENT_UPDATE,
        projectId,
        event: r
      });
    });
  }
  delete() {
    const action = async (dispatch, getState, {
      api
    }, projectId = this.projectId) => {
      let deleteEventReq = api;
      if (projectId) {
        deleteEventReq = deleteEventReq.project(projectId);
      }
      const deleteEventRes = await deleteEventReq.maintenanceEvent(this.id).delete();
      dispatch({
        type: MAINTENANCE_EVENT_REMOVE,
        projectId,
        id: typeof this.id === 'string' ? this.id : this.id?.id
      });
      return deleteEventRes;
    };
    return this.createAction('delete', 'deleting', action);
  }
  getStatus(state) {
    return getStatus(state, this.projectId, this.id);
  }
  getError(state) {
    return getError(state, this.projectId, this.id);
  }
  getMaintenanceEvent(state) {
    return getMaintenanceEvent(state, this.projectId, this.id);
  }
}
export default MaintenanceEvent;